export const environment = {
  production: false,
  serverUrl: 'https://vblite-api.dnvsspl.com/v1/',
  imageUrl: 'https://vblite-api.dnvsspl.com/v1/',
  pdfUrl: 'https://vblite-api.dnvsspl.com/v1/',

};
